import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { SaleListResponse } from '../../common/types/interfaces'

const initialState: { data: SaleListResponse } = {
  data: {
    data: [],
    total: 0,
  },
}

export const saleItemListSlice = createSlice({
  name: 'sale-item-list',
  initialState,
  reducers: {
    setSaleItemList: (state, action: PayloadAction<SaleListResponse>) => {
      state.data = { ...action.payload }
    },
  },
})

export const { setSaleItemList } = saleItemListSlice.actions

export const selectSaleItemList = (state: RootState) => state.saleItemList.data
export const selectSaleItem = (state: RootState, id: number) =>
  state.saleItemList.data.data.find((el) => el.id === id)

export default saleItemListSlice.reducer
